import { RouterProvider } from "react-router-dom";
import routes from "./routes";
import { Suspense } from "react";
import { Spin } from "antd";
import ErrorBoundary from "@/components/ErrorBoundary";
import { appQueryClient } from "@/query/client";
import QueryProvider from "@/query/provider";

function App() {
  return (
    // Root-level error boundaries prevent ordinary rendering exceptions from causing a full page white screen.
    <ErrorBoundary>
      <QueryProvider client={appQueryClient}>
        <Suspense fallback={<Spin size="large" style={{ width: "100%", marginTop: 150 }} />}>
          <RouterProvider router={routes} />
        </Suspense>
      </QueryProvider>
    </ErrorBoundary>
  );
}

export default App;
